<template>
<div id="1" class="container-fluid vh-100 bg-white text-dark d-flex justify-content-center align-items-center flex-column">
  <span id="name" class="title-text">Muhammet Huseyin Olgun</span>
  <div class="title-subtitle">Tech Lead, Developer, Consultant</div>
</div>
<div id="2" class="container-fluid vh-100 bg-white text-dark d-flex justify-content-center align-items-center">
  <div class="employer-section">
    <div v-motion-slide-visible-left :delay="200" class="subtitle-text">Former employee of</div>
    <div class="employer-list">
      <div v-for="(employer, index) in employers" :key="index"
           v-motion-slide-visible-right
           :delay="200 + (index * 200)">
        {{ employer }}
      </div>
    </div>
  </div>
</div>
<div id="3" class="container-fluid vh-100 bg-white text-dark d-flex justify-content-center align-items-center">
  <span ref="experienceRef" v-motion-slide-visible-down id="name" class="title-text">+{{ experienceYears }} </span> <span id="name" class="title-subtitle">years of experience.</span>
</div>
<div id="4" class="container-fluid vh-100 bg-white text-dark d-flex justify-content-center align-items-center">
  <span id="name" class="subtitle-text">Specialized on <b>distributed systems and its applications.</b> </span>
</div>
<div id="5" class="container-fluid vh-100 bg-white text-dark d-flex justify-content-center align-items-center">
  <div class="employer-section">
    <div class="subtitle-text">Get in touch</div>
    <div class="contact-list">
      <a v-for="(contact, index) in contacts" :key="index"
           :href="contact.url"
           :target="contact.target"
           v-motion-slide-visible-right
           :delay="200 + (index * 200)">
        {{ contact.text }}
      </a>
    </div>
  </div>
</div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const employers = ['trendyol', 'Thoughtworks', 'Turkcell']
const contacts = [
  { text: 'mh.olgun@gmail.com', url: 'mailto:mh.olgun@gmail.com', target: '_self' },
  { text: 'https://linkedin.com/in/molgun/', url: 'https://www.linkedin.com/in/molgun/', target: '_blank' },
  { text: 'https://github.com/molgun', url: 'https://github.com/molgun', target: '_blank' }
]
const experienceYears = ref(0)
const experienceRef = ref(null)

onMounted(() => {
  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      setTimeout(() => {
        let startTimestamp = null
        const step = (timestamp) => {
          if (!startTimestamp) startTimestamp = timestamp
          const progress = Math.min((timestamp - startTimestamp) / 2000, 1)
          experienceYears.value = Math.floor(progress * 12)
          if (progress < 1) window.requestAnimationFrame(step)
        }
        window.requestAnimationFrame(step)
      }, 1000)
      observer.disconnect()
    }
  })
  if (experienceRef.value) observer.observe(experienceRef.value)
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box {
    width: 100px;
    height: 100px;
    background-color: #0cdcf7;
    border-radius: 5px;
}

.title-text {
  font-size: 128px;
  margin-right: 12px;
}

.title-subtitle {
  font-size: 32px;
}

.subtitle-text {
  font-size: 50px;
}

.employer-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
}

.employer-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  gap: 40px;
}

.contact-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 10px;
  font-size: 32px;
  flex-direction: row;
}

.contact-list a {
  text-decoration: none;
  color: inherit;
}

.employer-list div {
  font-size: 92px;
}
/* Tablet screens */
@media (max-width: 1024px) {
  .title-text {
    font-size: 96px;
  }
  
  .title-subtitle {
    font-size: 24px;
  }

  .employer-list div {
    font-size: 60px;
  }

  .subtitle-text {
    font-size: 40px;
  }
}

/* Mobile screens */
@media (max-width: 768px) {
  .title-text {
    font-size: 64px;
  }
  
  .title-subtitle {
    font-size: 18px;
  }

  .title-text {
    margin-right: 0;
    text-align: center;
  }

  div[id="3"] {
    flex-direction: column;
  }

  .employer-list {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }

  .employer-list div {
    font-size: 48px;
  }

  .subtitle-text {
    font-size: 32px;
    text-align: center;
    padding: 0 20px;
  }

  .contact-list {
    flex-direction: column;
    align-items: center;
    font-size: 24px;
  }
}

/* Small mobile screens */
@media (max-width: 480px) {
  .title-text {
    font-size: 48px;
  }
  
  .title-subtitle {
    font-size: 14px;
  }

  .employer-list div {
    font-size: 32px;
  }

  .subtitle-text {
    font-size: 24px;
  }

  .contact-list {
    font-size: 18px;
  }
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
